import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { provideTablerIcons, TablerIconComponent } from 'angular-tabler-icons';
import { IconInfoCircle } from 'angular-tabler-icons/icons';
import { Tooltip } from 'primeng/tooltip';

// noinspection CssUnknownTarget
@Component({
  selector: 'app-tooltip',
  template: `
    <div
      class="tooltip-container"
      [pTooltip]="tooltipContent"
      tooltipPosition="top">
      <i-tabler class="icon" name="info-circle"></i-tabler>
    </div>
    <ng-template #tooltipContent>
      <div [innerHTML]="tooltip"></div>
    </ng-template>
  `,
  styles: `
    .tooltip-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 24px;
      height: 24px;
      border-radius: 8px;
      background-color: var(--p-blue-50);

      i-tabler {
        display: flex;
        justify-content: center;
        align-items: center;
        stroke: var(--p-blue-400);

        ::ng-deep {
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  `,
  imports: [Tooltip, TablerIconComponent],
  providers: [
    provideTablerIcons({
      IconInfoCircle,
    }),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {
  @Input() tooltip: string;
}
